import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { dashboardService, orgService, usuarioService, requerimientoService, ubicacionService, proveedorService } from '../services';
import { useAuth } from '../context/AuthContext';
import Modal from '../components/common/Modal';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const { usuario, esPresidente, esAdministracion, esVicepresidencia, esAsistenteVicepresidencia } = useAuth();
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'alert',
  });

  const showAlert = (message, type = 'alert', title = '') => {
    setModalConfig({
      isOpen: true,
      message,
      type,
      title: title || (type === 'error' ? '🚫 Error' : type === 'success' ? '✅ Éxito' : '⚠️ Aviso'),
    });
  };
  const [tabActiva, setTabActiva] = useState(esPresidente() ? 'dashboard' : 'usuarios');
  const [cargando, setCargando] = useState(true);

  // Datos base
  const [vicepresidencias, setVicepresidencias] = useState([]);
  const [gerencias, setGerencias] = useState([]);
  const [estados, setEstados] = useState([]);

  // Dashboard Tab
  const [datosDashboard, setDatosDashboard] = useState(null);
  const [filtros, setFiltros] = useState({
    vicepresidencia: '',
    gerencia: '',
    estado: '',
    fecha_desde: '',
    fecha_hasta: '',
  });

  // Requerimientos Tab
  const [requerimientos, setRequerimientos] = useState([]);
  const [reqFiltros, setReqFiltros] = useState({
    estado: '',
    vicepresidencia: '',
    gerencia: '',
  });

  // Usuarios Tab
  const [usuarios, setUsuarios] = useState([]);
  const [modalUsuario, setModalUsuario] = useState(false);
  const [usuarioEditando, setUsuarioEditando] = useState(null);
  const [usuarioForm, setUsuarioForm] = useState({
    username: '',
    email: '',
    password: '',
    first_name: '',
    last_name: '',
    cedula: '',
    vicepresidencia: '',
    role: '',
    telefono: '',
    estado_asignado: '',
    es_sede_central: false,
  });

  // Vicepresidencias Tab (CRUD)
  const [modalVP, setModalVP] = useState(false);
  const [vpEditando, setVpEditando] = useState(null);
  const [vpForm, setVpForm] = useState({
    nombre: '',
    abreviatura: '',
    descripcion: '',
    activa: true,
  });

  // Gerencias Tab (CRUD)
  const [modalGerencia, setModalGerencia] = useState(false);
  const [gerenciaEditando, setGerenciaEditando] = useState(null);
  const [gerenciaForm, setGerenciaForm] = useState({
    vicepresidencia: '',
    nombre: '',
    descripcion: '',
    activa: true,
  });

  // Auditoría Tab
  const [auditoriaEventos, setAuditoriaEventos] = useState([]);
  const [expandedEvents, setExpandedEvents] = useState({});
  const [auditoriaFiltros, setAuditoriaFiltros] = useState({
    usuario: '',
    vicepresidencia: '',
    accion: '',
    estado: '',
    fecha_desde: '',
    fecha_hasta: '',
  });
  const [accionesAuditoria, setAccionesAuditoria] = useState([]);

  // Configuración Tab
  const [configuracion, setConfiguracion] = useState(null);
  const [configForm, setConfigForm] = useState({});
  const [guardandoConfig, setGuardandoConfig] = useState(false);
  const [cargandoConfig, setCargandoConfig] = useState(false);

  // Proveedores
  const [tiposProveedores, setTiposProveedores] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [tiposDocumentos, setTiposDocumentos] = useState([]);
  const [cargandoProveedores, setCargandoProveedores] = useState(false);
  const [showNuevoProveedorModal, setShowNuevoProveedorModal] = useState(false);
  const [nuevoProveedorData, setNuevoProveedorData] = useState({
    tipo: '',
    nombre: '',
    tipo_documento: '',
    rif_numero: '',
  });
  const [errorProveedorModal, setErrorProveedorModal] = useState('');
  const [cargandoNuevoProveedor, setCargandoNuevoProveedor] = useState(false);
  const [showNuevaCategoriaModal, setShowNuevaCategoriaModal] = useState(false);
  const [nuevaCategoriaNombre, setNuevaCategoriaNombre] = useState('');
  const [cargandoNuevaCategoria, setCargandoNuevaCategoria] = useState(false);
  const [errorCategoriaModal, setErrorCategoriaModal] = useState('');
  const [categoriaEditando, setCategoriaEditando] = useState(null);
  const [proveedorEditando, setProveedorEditando] = useState(null);
  const [subTabProveedores, setSubTabProveedores] = useState('categorias');

  // Search and Pagination states for Categorias
  const [busquedaCategorias, setBusquedaCategorias] = useState('');
  const [paginaCategorias, setPaginaCategorias] = useState(1);
  const itemsPorPaginaCategorias = 10;

  // Search and Pagination states for Proveedores
  const [busquedaProveedores, setBusquedaProveedores] = useState('');
  const [paginaProveedores, setPaginaProveedores] = useState(1);
  const itemsPorPaginaProveedores = 10;

  // Password Modal
  const [modalPassword, setModalPassword] = useState(false);
  const [usuarioPassword, setUsuarioPassword] = useState(null);
  const [passwordForm, setPasswordForm] = useState({ nueva_password: '', confirmar_password: '' });
  const [guardandoPassword, setGuardandoPassword] = useState(false);

  // Pagination & Search local for Tabs
  const [busquedaGlobal, setBusquedaGlobal] = useState('');
  const [paginaGlobal, setPaginaGlobal] = useState(1);
  const itemsPorPagina = 10;

  // Inicialización de datos base
  useEffect(() => {
    const initBaseData = async () => {
      try {
        await Promise.all([
          cargarVicepresidencias(),
          cargarGerencias(),
          cargarEstados(),
        ]);
      } catch (error) {
        console.error('Error al inicializar datos base:', error);
      } finally {
        setCargando(false);
      }
    };
    initBaseData();
  }, []);

  // Recarga condicional por Tab activa
  useEffect(() => {
    setBusquedaGlobal('');
    setPaginaGlobal(1);

    if (tabActiva === 'dashboard') {
      cargarDashboard();
    } else if (tabActiva === 'requerimientos') {
      cargarRequerimientos();
    } else if (tabActiva === 'usuarios') {
      cargarUsuarios();
    } else if (tabActiva === 'vicepresidencias') {
      cargarVicepresidencias();
    } else if (tabActiva === 'gerencias') {
      cargarGerencias();
    } else if (tabActiva === 'auditoria') {
      cargarAuditoria();
    } else if (tabActiva === 'configuracion') {
      cargarConfiguracion();
    } else if (tabActiva === 'proveedores') {
      cargarTiposProveedores();
      cargarTiposDocumentos();
      cargarProveedores();
    }
  }, [tabActiva, filtros, reqFiltros]);

  // Carga de entidades
  const cargarVicepresidencias = async () => {
    try {
      const data = await orgService.getVicepresidencias();
      setVicepresidencias(data.results || data);
    } catch (error) {
      console.error('Error al cargar vicepresidencias:', error);
    }
  };

  const cargarGerencias = async () => {
    try {
      const data = await orgService.getGerencias();
      setGerencias(data.results || data);
    } catch (error) {
      console.error('Error al cargar gerencias:', error);
    }
  };

  const cargarEstados = async () => {
    try {
      const data = await ubicacionService.getEstados();
      setEstados(data.results || data);
    } catch (error) {
      console.error('Error al cargar estados:', error);
    }
  };

  const cargarDashboard = async () => {
    try {
      const data = await dashboardService.getFiltrado(filtros);
      setDatosDashboard(data);
    } catch (error) {
      console.error('Error al cargar dashboard:', error);
    }
  };

  const cargarUsuarios = async () => {
    try {
      const data = await usuarioService.getAll();
      setUsuarios(data.results || data);
    } catch (error) {
      console.error('Error al cargar usuarios:', error);
    }
  };

  const cargarRequerimientos = async () => {
    try {
      const data = await requerimientoService.getAll(reqFiltros);
      setRequerimientos(data.results || data);
    } catch (error) {
      console.error('Error al cargar requerimientos:', error);
    }
  };

  const cargarAuditoria = async () => {
    try {
      const data = await dashboardService.getAuditoria(auditoriaFiltros);
      setAuditoriaEventos(data.eventos || []);
      if (data.filtros_disponibles?.acciones) {
        setAccionesAuditoria(data.filtros_disponibles.acciones);
      }
    } catch (error) {
      console.error('Error al cargar auditoría:', error);
    }
  };

  const cargarConfiguracion = async () => {
    try {
      const data = await dashboardService.getConfiguracion();
      setConfiguracion(data);
      setConfigForm(data);
    } catch (error) {
      console.error('Error al cargar configuración:', error);
    }
  };

  const guardarConfiguracion = async () => {
    try {
      setGuardandoConfig(true);
      const data = await dashboardService.guardarConfiguracion(configForm);
      setConfiguracion(data.config);
      showAlert('Configuración guardada correctamente', 'success');
    } catch (error) {
      console.error('Error al guardar configuración:', error);
      showAlert('Error al guardar la configuración', 'error');
    } finally {
      setGuardandoConfig(false);
    }
  };

  const handleConfigChange = (e) => {
    const { name, value, type, checked } = e.target;
    setConfigForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // Handlers de filtros de Dashboard
  const handleFiltroChange = (e) => {
    const { name, value } = e.target;
    setFiltros(prev => ({ ...prev, [name]: value }));
  };

  const limpiarFiltros = () => {
    setFiltros({ vicepresidencia: '', gerencia: '', estado: '', fecha_desde: '', fecha_hasta: '' });
  };

  // Handlers de filtros de Auditoría
  const handleAuditoriaFiltroChange = (e) => {
    const { name, value } = e.target;
    setAuditoriaFiltros(prev => ({ ...prev, [name]: value }));
  };

  const limpiarAuditoriaFiltros = async () => {
    const vacios = { usuario: '', vicepresidencia: '', accion: '', estado: '', fecha_desde: '', fecha_hasta: '' };
    setAuditoriaFiltros(vacios);
    try {
      const data = await dashboardService.getAuditoria(vacios);
      setAuditoriaEventos(data.eventos || []);
    } catch (error) {
      console.error('Error al cargar auditoría:', error);
    }
  };

  const toggleEventExpand = (id) => {
    setExpandedEvents(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  // CRUD Vicepresidencias
  const abrirModalVP = (vp = null) => {
    if (vp) {
      setVpEditando(vp);
      setVpForm({
        nombre: vp.nombre,
        abreviatura: vp.abreviatura,
        descripcion: vp.descripcion || '',
        activa: vp.activa,
      });
    } else {
      setVpEditando(null);
      setVpForm({
        nombre: '',
        abreviatura: '',
        descripcion: '',
        activa: true,
      });
    }
    setModalVP(true);
  };

  const guardarVP = async () => {
    if (!vpForm.nombre || !vpForm.abreviatura) {
      showAlert('Nombre y abreviatura son requeridos', 'warning');
      return;
    }
    try {
      if (vpEditando) {
        await orgService.updateVicepresidencia(vpEditando.id, vpForm);
      } else {
        await orgService.createVicepresidencia(vpForm);
      }
      setModalVP(false);
      cargarVicepresidencias();
    } catch (error) {
      console.error('Error al guardar VP:', error);
      showAlert('Error al guardar la Vicepresidencia: ' + (error.response?.data?.detail || error.message), 'error');
    }
  };

  const toggleVP = async (vp) => {
    try {
      await orgService.updateVicepresidencia(vp.id, { activa: !vp.activa });
      cargarVicepresidencias();
    } catch (error) {
      console.error('Error al cambiar estado VP:', error);
      showAlert('Error al actualizar el estatus de la Vicepresidencia', 'error');
    }
  };

  // CRUD Gerencias
  const abrirModalGerencia = (ger = null) => {
    if (ger) {
      setGerenciaEditando(ger);
      setGerenciaForm({
        vicepresidencia: ger.vicepresidencia,
        nombre: ger.nombre,
        descripcion: ger.descripcion || '',
        activa: ger.activa,
      });
    } else {
      setGerenciaEditando(null);
      setGerenciaForm({
        vicepresidencia: !esPresidente() ? (usuario?.vicepresidencia?.id || usuario?.vicepresidencia || '') : (vicepresidencias[0]?.id || ''),
        nombre: '',
        descripcion: '',
        activa: true,
      });
    }
    setModalGerencia(true);
  };

  const guardarGerencia = async () => {
    if (!gerenciaForm.nombre || !gerenciaForm.vicepresidencia) {
      showAlert('Nombre y Vicepresidencia asociada son obligatorios', 'warning');
      return;
    }
    try {
      if (gerenciaEditando) {
        await orgService.updateGerencia(gerenciaEditando.id, gerenciaForm);
      } else {
        await orgService.createGerencia(gerenciaForm);
      }
      setModalGerencia(false);
      cargarGerencias();
    } catch (error) {
      console.error('Error al guardar gerencia:', error);
      showAlert('Error al guardar la Gerencia: ' + (error.response?.data?.detail || JSON.stringify(error.response?.data) || error.message), 'error');
    }
  };

  const toggleGerencia = async (ger) => {
    try {
      await orgService.updateGerencia(ger.id, { activa: !ger.activa });
      cargarGerencias();
    } catch (error) {
      console.error('Error al cambiar estado gerencia:', error);
      showAlert('Error al actualizar el estatus de la Gerencia', 'error');
    }
  };

  // CRUD Usuarios
  const abrirModalUsuario = (usuarioToEdit = null) => {
    if (usuarioToEdit) {
      setUsuarioEditando(usuarioToEdit);
      setUsuarioForm({
        username: usuarioToEdit.username,
        email: usuarioToEdit.email,
        password: '',
        first_name: usuarioToEdit.first_name || '',
        last_name: usuarioToEdit.last_name || '',
        vicepresidencia: usuarioToEdit.vicepresidencia || '',
        role: usuarioToEdit.role,
        telefono: usuarioToEdit.telefono || '',
        estado_asignado: usuarioToEdit.estado_asignado || '',
        es_sede_central: usuarioToEdit.es_sede_central !== false, // Por defecto true si no está seteado
      });
    } else {
      setUsuarioEditando(null);
      setUsuarioForm({
        username: '',
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        vicepresidencia: !esPresidente() ? (usuario?.vicepresidencia?.id || usuario?.vicepresidencia || '') : '',
        role: esAsistenteVicepresidencia() ? 'analista' : (esAdministracion() ? 'analista_administracion' : ''),
        telefono: '',
        estado_asignado: '',
        es_sede_central: true,
      });
    }
    setModalUsuario(true);
  };

  const guardarUsuario = async () => {
    const data = { ...usuarioForm };

    if (data.role === 'analista' && !data.es_sede_central) {
      if (!data.estado_asignado) {
        showAlert('Los analistas regionales deben tener un estado asignado.', 'warning');
        return;
      }
    } else {
      data.estado_asignado = null;
    }

    const rolesSinVp = ['presidente', 'administracion', 'analista_administracion'];
    if (!rolesSinVp.includes(data.role) && !data.vicepresidencia) {
      showAlert('Este rol requiere asignar una Vicepresidencia.', 'warning');
      return;
    }
    if (rolesSinVp.includes(data.role)) {
      data.vicepresidencia = null;
    }

    try {
      if (!usuarioEditando) {
        if (!data.password) {
          showAlert('La contraseña es obligatoria para nuevos usuarios', 'warning');
          return;
        }
        await usuarioService.create(data);
      } else {
        delete data.password;
        if (!data.password) delete data.password;
        await usuarioService.update(usuarioEditando.id, data);
      }
      setModalUsuario(false);
      await cargarUsuarios();
    } catch (error) {
      console.error('Error al guardar usuario:', error);
      showAlert('Error al guardar el usuario: ' + (error.response?.data?.detail || JSON.stringify(error.response?.data) || error.message), 'error');
    }
  };

  const canToggleStatus = (targetUser) => {
    // El presidente es super admin. No se puede desactivar a sí mismo ni a través de la UI.
    if (targetUser.role === 'presidente') {
      return false;
    }

    // Un VP o el Presidente no pueden desactivarse a sí mismos.
    if (targetUser.id === usuario?.id) {
      if (usuario?.es_vp || usuario?.es_presidente || ['vicepresidencia', 'presidente'].includes(targetUser.role)) {
        return false;
      }
    }

    // Los VPs solo pueden desactivar analistas de su misma vicepresidencia.
    // No pueden desactivar a otros VPs ni al Presidente.
    const loggedIsVp = usuario?.es_vp || usuario?.role === 'vicepresidencia';
    if (loggedIsVp) {
      const targetIsVpOrPresident = ['vicepresidencia', 'presidente'].includes(targetUser.role);
      if (targetIsVpOrPresident) {
        return false;
      }
    }

    return true;
  };

  const toggleUsuario = async (userToToggle) => {
    if (!canToggleStatus(userToToggle)) {
      showAlert('No tiene los permisos requeridos para cambiar el estatus de este usuario.', 'warning');
      return;
    }
    try {
      await usuarioService.update(userToToggle.id, { activo: !userToToggle.activo });
      await cargarUsuarios();
    } catch (error) {
      console.error('Error al alternar estado del usuario:', error);
      showAlert('Error al actualizar el usuario', 'error');
    }
  };

  const abrirModalPassword = (usuario) => {
    setUsuarioPassword(usuario);
    setPasswordForm({ nueva_password: '', confirmar_password: '' });
    setModalPassword(true);
  };

  const guardarPassword = async () => {
    if (passwordForm.nueva_password !== passwordForm.confirmar_password) {
      showAlert('Las contraseñas no coinciden', 'warning');
      return;
    }
    if (passwordForm.nueva_password.length < 8) {
      showAlert('La contraseña debe tener al menos 8 caracteres', 'warning');
      return;
    }
    try {
      setGuardandoPassword(true);
      await usuarioService.cambiarPassword(usuarioPassword.id, passwordForm.nueva_password);
      setModalPassword(false);
      showAlert('Contraseña cambiada correctamente', 'success');
    } catch (error) {
      console.error('Error al cambiar contraseña:', error);
      showAlert('Error al cambiar la contraseña', 'error');
    } finally {
      setGuardandoPassword(false);
    }
  };

  // Requerimientos
  const cambiarEstadoReq = async (id, nuevoEstado) => {
    try {
      await requerimientoService.cambiarEstado(id, nuevoEstado, 'Cambiado por administrador');
      await cargarRequerimientos();
    } catch (error) {
      showAlert('Error al cambiar el estatus', 'error');
    }
  };

  const getEstadoColor = (estado) => {
    const colores = {
      elaborado: '#6b7280',
      por_revision: '#d97706',
      aprobado_vicepresidencia: '#0891b2',
      rechazado_vicepresidencia: '#b91c1c',
      recibido_administracion: '#1e3a5f',
      aprobado_administracion: '#0d9488',
      rechazado_administracion: '#b91c1c',
      pagado_parcial: '#7c3aed',
      pagado: '#0f766e',
    };
    return colores[estado] || '#6b7280';
  };

  const getEstadoLabel = (estado) => {
    const labels = {
      elaborado: 'Elaborado',
      por_revision: 'Por Revisión',
      aprobado_vicepresidencia: 'Aprobado por VP',
      rechazado_vicepresidencia: 'Rechazado por VP',
      recibido_administracion: 'Recibido por Administración',
      aprobado_administracion: 'Aprobado por Administración',
      rechazado_administracion: 'Rechazado por Administración',
      pagado_parcial: 'Pagado Parcial',
      pagado: 'Pagado',
    };
    return labels[estado] || estado;
  };

  // Formateador de fecha compacto y limpio
  const formatFechaStr = (fechaStr) => {
    if (!fechaStr) return '—';
    const date = new Date(fechaStr);
    if (isNaN(date.getTime())) return fechaStr;
    const pad = (n) => String(n).padStart(2, '0');
    const d = pad(date.getDate());
    const m = pad(date.getMonth() + 1);
    const y = date.getFullYear();
    const h = pad(date.getHours());
    const min = pad(date.getMinutes());
    const s = pad(date.getSeconds());
    return `${d}/${m}/${y} ${h}:${min}:${s}`;
  };

  // Renderizador de JSON snapshot diffs
  const renderDiff = (anteriores, nuevos) => {
    if (!anteriores && !nuevos) return <div className="no-diffs">Sin cambios detallados</div>;
    const keys = Array.from(new Set([...Object.keys(anteriores || {}), ...Object.keys(nuevos || {})]));
    const filterKeys = keys.filter(k => {
      // Ignorar fechas de modificación y claves internas
      if (['fecha_modificacion', 'id'].includes(k)) return false;
      const valAnt = anteriores ? anteriores[k] : null;
      const valNue = nuevos ? nuevos[k] : null;
      return JSON.stringify(valAnt) !== JSON.stringify(valNue);
    });

    if (filterKeys.length === 0) return <div className="no-diffs">Sin cambios significativos</div>;

    return (
      <div className="diff-container">
        <table className="diff-table">
          <thead>
            <tr>
              <th>Campo</th>
              <th>Valor Anterior</th>
              <th>Valor Nuevo</th>
            </tr>
          </thead>
          <tbody>
            {filterKeys.map(k => {
              const valAnt = anteriores ? anteriores[k] : null;
              const valNue = nuevos ? nuevos[k] : null;
              return (
                <tr key={k}>
                  <td className="diff-field">{k}</td>
                  <td className="diff-old">{valAnt !== null ? String(valAnt) : '—'}</td>
                  <td className="diff-new">{valNue !== null ? String(valNue) : '—'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  const cargarTiposProveedores = async () => {
    try {
      const data = await proveedorService.getTiposProveedores();
      const list = Array.isArray(data) ? data : (data?.results || []);
      setTiposProveedores(list);
    } catch (err) {
      console.error('Error al cargar tipos de proveedores:', err);
    }
  };

  const cargarProveedores = async () => {
    try {
      setCargandoProveedores(true);
      const data = await proveedorService.getProveedores();
      const list = Array.isArray(data) ? data : (data?.results || []);
      setProveedores(list);
    } catch (err) {
      console.error('Error al cargar proveedores:', err);
    } finally {
      setCargandoProveedores(false);
    }
  };

  const cargarTiposDocumentos = async () => {
    try {
      const data = await proveedorService.getTiposDocumentos();
      const list = Array.isArray(data) ? data : (data?.results || []);
      setTiposDocumentos(list);
    } catch (err) {
      console.error('Error al cargar tipos de documentos:', err);
    }
  };

  const abrirModalNuevaCategoria = (categoria = null) => {
    setCategoriaEditando(categoria);
    setNuevaCategoriaNombre(categoria ? categoria.nombre : '');
    setErrorCategoriaModal('');
    setShowNuevaCategoriaModal(true);
  };

  const handleCrearCategoria = async (e) => {
    e.preventDefault();
    if (!nuevaCategoriaNombre.trim()) return;
    setErrorCategoriaModal('');
    setCargandoNuevaCategoria(true);
    try {
      if (categoriaEditando) {
        const updated = await proveedorService.updateTipoProveedor(categoriaEditando.id, { nombre: nuevaCategoriaNombre });
        setTiposProveedores(prev => prev.map(c => c.id === updated.id ? updated : c).sort((a, b) => a.nombre.localeCompare(b.nombre)));
        showAlert('Categoría actualizada con éxito', 'success');
      } else {
        const nuevaCat = await proveedorService.crearTipoProveedor({ nombre: nuevaCategoriaNombre });
        setTiposProveedores(prev => [...prev, nuevaCat].sort((a, b) => a.nombre.localeCompare(b.nombre)));
        showAlert('Categoría creada con éxito', 'success');
      }
      setNuevaCategoriaNombre('');
      setShowNuevaCategoriaModal(false);
      setCategoriaEditando(null);
    } catch (err) {
      setErrorCategoriaModal(err.response?.data?.nombre || 'Error al guardar la categoría.');
    } finally {
      setCargandoNuevaCategoria(false);
    }
  };

  const toggleCategoria = async (categoria) => {
    try {
      const updated = await proveedorService.updateTipoProveedor(categoria.id, { activo: !categoria.activo });
      setTiposProveedores(prev => prev.map(c => c.id === updated.id ? updated : c));
      showAlert(`Categoría ${updated.activo ? 'activada' : 'desactivada'} con éxito`, 'success');
    } catch (err) {
      showAlert('Error al cambiar el estado de la categoría', 'error');
    }
  };

  const abrirModalNuevoProveedor = (proveedor = null) => {
    setProveedorEditando(proveedor);
    if (proveedor) {
      setNuevoProveedorData({
        tipo: proveedor.tipo || '',
        nombre: proveedor.nombre || '',
        tipo_documento: proveedor.tipo_documento || '',
        rif_numero: proveedor.rif_numero || '',
      });
    } else {
      setNuevoProveedorData({
        tipo: '',
        nombre: '',
        tipo_documento: '',
        rif_numero: '',
      });
    }
    setErrorProveedorModal('');
    setShowNuevoProveedorModal(true);
  };

  const handleCrearProveedor = async (e) => {
    e.preventDefault();
    if (!nuevoProveedorData.tipo || !nuevoProveedorData.nombre || !nuevoProveedorData.tipo_documento || !nuevoProveedorData.rif_numero) {
      setErrorProveedorModal('Complete todos los campos obligatorios.');
      return;
    }
    setErrorProveedorModal('');
    setCargandoNuevoProveedor(true);
    try {
      if (proveedorEditando) {
        const updated = await proveedorService.updateProveedor(proveedorEditando.id, nuevoProveedorData);
        setProveedores(prev => prev.map(p => p.id === updated.id ? updated : p).sort((a, b) => a.nombre.localeCompare(b.nombre)));
        showAlert('Proveedor actualizado con éxito', 'success');
      } else {
        const nuevoProv = await proveedorService.crearProveedor(nuevoProveedorData);
        setProveedores(prev => [...prev, nuevoProv].sort((a, b) => a.nombre.localeCompare(b.nombre)));
        showAlert('Proveedor registrado con éxito', 'success');
      }
      setShowNuevoProveedorModal(false);
      setProveedorEditando(null);
    } catch (err) {
      const apiError = err.response?.data;
      if (apiError && typeof apiError === 'object') {
        if (apiError.rif_numero) {
          setErrorProveedorModal(`RIF: ${apiError.rif_numero}`);
        } else if (apiError.rif) {
          setErrorProveedorModal(`RIF: ${apiError.rif}`);
        } else if (apiError.nombre) {
          setErrorProveedorModal(`Nombre: ${apiError.nombre}`);
        } else {
          const firstKey = Object.keys(apiError)[0];
          setErrorProveedorModal(`${firstKey}: ${apiError[firstKey]}`);
        }
      } else {
        setErrorProveedorModal(err.response?.data?.detail || 'Error al guardar el proveedor.');
      }
    } finally {
      setCargandoNuevoProveedor(false);
    }
  };

  const toggleProveedor = async (proveedor) => {
    try {
      const updated = await proveedorService.updateProveedor(proveedor.id, { activo: !proveedor.activo });
      setProveedores(prev => prev.map(p => p.id === updated.id ? updated : p));
      showAlert(`Proveedor ${updated.activo ? 'activado' : 'desactivado'} con éxito`, 'success');
    } catch (err) {
      showAlert('Error al cambiar el estado del proveedor', 'error');
    }
  };

  const allTabs = [
    { id: 'dashboard', label: 'Estadísticas', icon: '📊', roles: ['presidente'] },
    { id: 'usuarios', label: 'Usuarios', icon: '👥', roles: ['presidente', 'vicepresidencia', 'administracion'] },
    { id: 'vicepresidencias', label: 'Vicepresidencias', icon: '🏢', roles: ['presidente'] },
    { id: 'gerencias', label: 'Gerencias', icon: '📁', roles: ['presidente', 'vicepresidencia'] },
    { id: 'auditoria', label: 'Auditoría', icon: '🔎', roles: ['presidente'] },
    { id: 'configuracion', label: 'Configuración', icon: '⚙️', roles: ['presidente'] },
    { id: 'proveedores', label: 'Proveedores', icon: '🤝', roles: ['presidente', 'administracion'] },
  ];

  const currentRole = esPresidente() ? 'presidente' : esAdministracion() ? 'administracion' : esVicepresidencia() ? 'vicepresidencia' : '';
  const tabs = allTabs.filter(tab => tab.roles.includes(currentRole));

  if (cargando) return <div className="loading">Cargando...</div>;

  const headerTitle = esPresidente()
    ? 'Panel de Administración del Presidente'
    : 'Gestión de Usuarios';

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <h2>{headerTitle}</h2>
        <nav className="admin-tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab-btn ${tabActiva === tab.id ? 'active' : ''}`}
              onClick={() => setTabActiva(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* ==================== DASHBOARD TAB ==================== */}
      {tabActiva === 'dashboard' && (
        <div className="tab-content">
          <div className="filtros-container">
            <h3>Filtro de Estadísticas</h3>
            <div className="filtros-grid">
              <div className="form-group">
                <label>Vicepresidencia</label>
                <select name="vicepresidencia" value={filtros.vicepresidencia} onChange={handleFiltroChange}>
                  <option value="">Todas</option>
                  {vicepresidencias.map(vp => (
                    <option key={vp.id} value={vp.id}>{vp.nombre}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Gerencia</label>
                <select name="gerencia" value={filtros.gerencia} onChange={handleFiltroChange}>
                  <option value="">Todas</option>
                  {gerencias
                    .filter(g => !filtros.vicepresidencia || g.vicepresidencia === parseInt(filtros.vicepresidencia))
                    .map(g => (
                      <option key={g.id} value={g.id}>{g.nombre}</option>
                    ))}
                </select>
              </div>
              <div className="form-group">
                <label>Estatus Requerimiento</label>
                <select name="estado" value={filtros.estado} onChange={handleFiltroChange}>
                  <option value="">Todos</option>
                  {datosDashboard?.filtros_disponibles?.estados?.map(est => (
                    <option key={est.value} value={est.value}>{est.label}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Fecha Desde</label>
                <input type="date" name="fecha_desde" value={filtros.fecha_desde} onChange={handleFiltroChange} />
              </div>
              <div className="form-group">
                <label>Fecha Hasta</label>
                <input type="date" name="fecha_hasta" value={filtros.fecha_hasta} onChange={handleFiltroChange} />
              </div>
            </div>
            <div className="filtros-actions">
              <button className="btn-secondary" onClick={limpiarFiltros}>Limpiar Filtros</button>
              <button className="btn-primary" onClick={cargarDashboard}>Aplicar Filtros</button>
            </div>
          </div>

          {datosDashboard && (
            <>
              <div className="stats-grid">
                <div className="stat-card">
                  <div className="stat-icon primary">📋</div>
                  <div className="stat-content">
                    <h3>Total Requerimientos</h3>
                    <p className="stat-number">{datosDashboard.total_filtrados}</p>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon success">💸</div>
                  <div className="stat-content">
                    <h3>Monto Total Solicitado</h3>
                    <p className="stat-number">{parseFloat(datosDashboard.monto_total_filtrado || 0).toLocaleString('es-VE')} Bs</p>
                  </div>
                </div>
              </div>

              <div className="por-estado">
                <h3>Requerimientos por Estatus</h3>
                <div className="estados-grid">
                  {datosDashboard.por_estado.map(item => (
                    <div key={item.estado_actual} className="estado-card">
                      <span className="estado-dot" style={{ backgroundColor: getEstadoColor(item.estado_actual) }} />
                      <span className="estado-label">{getEstadoLabel(item.estado_actual)}</span>
                      <span className="estado-count">{item.cantidad}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="be-table-wrapper">
                <div className="be-card-header">
                  <h3>Requerimientos Recientes</h3>
                  {(() => {
                    const filtrados = datosDashboard.requerimientos.filter(req => {
                      const texto = `${req.correlativo} ${req.solicitante} ${req.vicepresidencia} ${req.gerencia} ${req.estado_display}`.toLowerCase();
                      return texto.includes(busquedaGlobal.toLowerCase());
                    });
                    return <span className="be-count-pill">{filtrados.length} EN TOTAL</span>;
                  })()}
                </div>

                {datosDashboard.requerimientos.length > 0 && (
                  <div className="be-search-bar">
                    <input
                      type="text"
                      placeholder="🔍 Buscar por código, solicitante, área..."
                      value={busquedaGlobal}
                      onChange={(e) => {
                        setBusquedaGlobal(e.target.value);
                        setPaginaGlobal(1);
                      }}
                      className="be-search-input"
                    />
                  </div>
                )}

                <div className="be-table-responsive">
                  <table className="be-table">
                    <thead>
                      <tr>
                        <th>Código</th>
                        <th>Solicitante</th>
                        <th>Vicepresidencia</th>
                        <th>Gerencia</th>
                        <th>Monto (Bs)</th>
                        <th>Estatus</th>
                        <th>Fecha de Creación</th>
                        <th className="text-right">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(() => {
                        const filtrados = datosDashboard.requerimientos.filter(req => {
                          const texto = `${req.correlativo} ${req.solicitante} ${req.vicepresidencia} ${req.gerencia} ${req.estado_display}`.toLowerCase();
                          return texto.includes(busquedaGlobal.toLowerCase());
                        });
                        const indiceUltimo = paginaGlobal * itemsPorPagina;
                        const indicePrimero = indiceUltimo - itemsPorPagina;
                        const paginados = filtrados.slice(indicePrimero, indiceUltimo);

                        if (filtrados.length === 0) {
                          return (
                            <tr>
                              <td colSpan="8" className="text-center" style={{ padding: '30px', color: 'var(--text-muted)' }}>
                                No se encontraron requerimientos que coincidan con su búsqueda.
                              </td>
                            </tr>
                          );
                        }

                        return paginados.map(req => (
                          <tr key={req.id}>
                            <td><strong>{req.codigo}</strong></td>
                            <td>{req.solicitante}</td>
                            <td>{req.vicepresidencia || '—'}</td>
                            <td>{req.gerencia || '—'}</td>
                            <td>{parseFloat(req.monto).toLocaleString('es-VE')} Bs</td>
                            <td>
                              <span className="estado-badge" style={{ backgroundColor: getEstadoColor(req.estado), color: '#ffffff' }}>
                                {req.estado_display}
                              </span>
                            </td>
                            <td>{new Date(req.fecha_creacion).toLocaleDateString('es-VE')}</td>
                            <td className="text-right"><Link to={`/requerimientos/${req.correlativo || req.id}`} className="btn-link-action">Ver Detalle →</Link></td>
                          </tr>
                        ));
                      })()}
                    </tbody>
                  </table>
                </div>
                {(() => {
                  const filtrados = datosDashboard.requerimientos.filter(req => {
                    const texto = `${req.correlativo} ${req.solicitante} ${req.vicepresidencia} ${req.gerencia} ${req.estado_display}`.toLowerCase();
                    return texto.includes(busquedaGlobal.toLowerCase());
                  });
                  const totalPaginas = Math.ceil(filtrados.length / itemsPorPagina);
                  if (filtrados.length <= itemsPorPagina) return null;

                  const indiceUltimo = Math.min(paginaGlobal * itemsPorPagina, filtrados.length);
                  const indicePrimero = (paginaGlobal - 1) * itemsPorPagina + 1;

                  return (
                    <div className="be-pagination-bar">
                      <button
                        onClick={() => setPaginaGlobal(prev => Math.max(prev - 1, 1))}
                        disabled={paginaGlobal === 1}
                        className="be-pagination-btn"
                      >
                        Anterior
                      </button>
                      <span className="be-pagination-info">
                        Página {paginaGlobal} de {totalPaginas}
                      </span>
                      <button
                        onClick={() => setPaginaGlobal(prev => Math.min(prev + 1, totalPaginas))}
                        disabled={paginaGlobal >= totalPaginas}
                        className="be-pagination-btn"
                      >
                        Siguiente
                      </button>
                    </div>
                  );
                })()}
              </div>
            </>
          )}
        </div>
      )}

      {/* ==================== REQUERIMIENTOS TAB ==================== */}
      {tabActiva === 'requerimientos' && (
        <div className="tab-content bandeja-entrada">
          <div className="lista-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h2 className="bandeja-entrada-titulo">
              <span className="titulo-icono">📋</span>
              Gestión Global de Requerimientos
            </h2>
            <div className="filtros-rapidos" style={{ display: 'flex', gap: '10px' }}>
              <select value={reqFiltros.estado} onChange={e => setReqFiltros(p => ({ ...p, estado: e.target.value }))} style={{ padding: '8px', borderRadius: '6px', border: '1px solid var(--border)', background: 'var(--bg-card)', color: 'var(--text)' }}>
                <option value="">Todos los Estatus</option>
                {datosDashboard?.filtros_disponibles?.estados?.map(est => (
                  <option key={est.value} value={est.value}>{est.label}</option>
                ))}
              </select>
              <select value={reqFiltros.vicepresidencia} onChange={e => setReqFiltros(p => ({ ...p, vicepresidencia: e.target.value }))} style={{ padding: '8px', borderRadius: '6px', border: '1px solid var(--border)', background: 'var(--bg-card)', color: 'var(--text)' }}>
                <option value="">Todas las VPs</option>
                {vicepresidencias.map(vp => (
                  <option key={vp.id} value={vp.id}>{vp.nombre}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="be-table-wrapper">
            <div className="be-card-header">
              <h3>Directorio de Requerimientos</h3>
              {(() => {
                const filtrados = requerimientos.filter(req => {
                  const texto = `${req.correlativo} ${req.solicitante_nombre} ${req.solicitante_apellido} ${req.vicepresidencia_nombre} ${req.gerencia_nombre} ${req.estado_display}`.toLowerCase();
                  return texto.includes(busquedaGlobal.toLowerCase());
                });
                return <span className="be-count-pill">{filtrados.length} EN TOTAL</span>;
              })()}
            </div>

            {requerimientos.length > 0 && (
              <div className="be-search-bar">
                <input
                  type="text"
                  placeholder="🔍 Buscar por código, solicitante, área..."
                  value={busquedaGlobal}
                  onChange={(e) => {
                    setBusquedaGlobal(e.target.value);
                    setPaginaGlobal(1);
                  }}
                  className="be-search-input"
                />
              </div>
            )}

            <div className="be-table-responsive">
              <table className="be-table">
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Solicitante</th>
                    <th>Vicepresidencia</th>
                    <th>Gerencia</th>
                    <th>Monto (Bs)</th>
                    <th>Estatus</th>
                    <th>Fecha</th>
                    <th className="text-right">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    const filtrados = requerimientos.filter(req => {
                      const texto = `${req.correlativo} ${req.solicitante_nombre} ${req.solicitante_apellido} ${req.vicepresidencia_nombre} ${req.gerencia_nombre} ${req.estado_display}`.toLowerCase();
                      return texto.includes(busquedaGlobal.toLowerCase());
                    });
                    const indiceUltimo = paginaGlobal * itemsPorPagina;
                    const indicePrimero = indiceUltimo - itemsPorPagina;
                    const paginados = filtrados.slice(indicePrimero, indiceUltimo);

                    if (filtrados.length === 0) {
                      return (
                        <tr>
                          <td colSpan="8" className="text-center" style={{ padding: '30px', color: 'var(--text-muted)' }}>
                            No se encontraron requerimientos.
                          </td>
                        </tr>
                      );
                    }

                    return paginados.map(req => (
                      <tr key={req.id}>
                        <td><strong>{req.correlativo}</strong></td>
                        <td>{req.solicitante_nombre} {req.solicitante_apellido}</td>
                        <td>{req.vicepresidencia_nombre || '—'}</td>
                        <td>{req.gerencia_nombre || '—'}</td>
                        <td>{parseFloat(req.monto_bs).toLocaleString('es-VE')} Bs</td>
                        <td>
                          <span className="estado-badge" style={{ backgroundColor: getEstadoColor(req.estado_actual), color: '#ffffff' }}>
                            {req.estado_display || req.estado_actual}
                          </span>
                        </td>
                        <td>{new Date(req.fecha_creacion).toLocaleDateString('es-VE')}</td>
                        <td className="text-right">
                          <Link to={`/requerimientos/${req.correlativo || req.id}`} className="btn-link-action">Ver →</Link>
                        </td>
                      </tr>
                    ));
                  })()}
                </tbody>
              </table>
            </div>

            {(() => {
              const filtrados = requerimientos.filter(req => {
                const texto = `${req.correlativo} ${req.solicitante_nombre} ${req.solicitante_apellido} ${req.vicepresidencia_nombre} ${req.gerencia_nombre} ${req.estado_display}`.toLowerCase();
                return texto.includes(busquedaGlobal.toLowerCase());
              });
              const totalPaginas = Math.ceil(filtrados.length / itemsPorPagina);
              if (filtrados.length <= itemsPorPagina) return null;

              const indiceUltimo = Math.min(paginaGlobal * itemsPorPagina, filtrados.length);
              const indicePrimero = (paginaGlobal - 1) * itemsPorPagina + 1;

              return (
                <div className="be-pagination-bar">
                  <button
                    onClick={() => setPaginaGlobal(prev => Math.max(prev - 1, 1))}
                    disabled={paginaGlobal === 1}
                    className="be-pagination-btn"
                  >
                    Anterior
                  </button>
                  <span className="be-pagination-info">
                    Página {paginaGlobal} de {totalPaginas}
                  </span>
                  <button
                    onClick={() => setPaginaGlobal(prev => Math.min(prev + 1, totalPaginas))}
                    disabled={paginaGlobal >= totalPaginas}
                    className="be-pagination-btn"
                  >
                    Siguiente
                  </button>
                </div>
              );
            })()}
          </div>
        </div>
      )}

      {/* ==================== USUARIOS TAB ==================== */}
      {tabActiva === 'usuarios' && (() => {
        const usuariosPermitidos = usuarios.filter(u => {
          if (esPresidente()) return true;
          if (esAdministracion()) return ['administracion', 'analista_administracion'].includes(u.role);
          if (esVicepresidencia() || esAsistenteVicepresidencia()) {
            const miVpId = typeof usuario?.vicepresidencia === 'object' ? usuario?.vicepresidencia?.id : usuario?.vicepresidencia;
            const uVpId = typeof u.vicepresidencia === 'object' ? u.vicepresidencia?.id : u.vicepresidencia;
            return miVpId === uVpId;
          }
          return false;
        });

        const filtrados = usuariosPermitidos.filter(u => {
          const texto = `${u.username} ${u.first_name} ${u.last_name} ${u.email} ${u.role_display} ${u.vicepresidencia_nombre}`.toLowerCase();
          return texto.includes(busquedaGlobal.toLowerCase());
        });

        const totalPaginas = Math.ceil(filtrados.length / itemsPorPagina);
        const indiceUltimo = paginaGlobal * itemsPorPagina;
        const indicePrimero = indiceUltimo - itemsPorPagina;
        const paginados = filtrados.slice(indicePrimero, indiceUltimo);

        return (
          <div className="tab-content bandeja-entrada">
            <div className="lista-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2 className="bandeja-entrada-titulo">
                <span className="titulo-icono">⚙️</span>
                Gestión del Sistema
              </h2>
              <button className="btn-primary" onClick={() => abrirModalUsuario()}>+ Nuevo Usuario</button>
            </div>

            <div className="be-table-wrapper">
              <div className="be-card-header">
                <h3>Directorio de Usuarios</h3>
                <span className="be-count-pill">{filtrados.length} EN TOTAL</span>
              </div>

              {usuariosPermitidos.length > 0 && (
                <div className="be-search-bar">
                  <input
                    type="text"
                    placeholder="🔍 Buscar por nombre, usuario, rol..."
                    value={busquedaGlobal}
                    onChange={(e) => {
                      setBusquedaGlobal(e.target.value);
                      setPaginaGlobal(1);
                    }}
                    className="be-search-input"
                  />
                </div>
              )}

              <div className="be-table-responsive">
                <table className="be-table">
                  <thead>
                    <tr>
                      <th>Usuario</th>
                      <th>Nombre Completo</th>
                      <th>Email</th>
                      <th>Vicepresidencia</th>
                      <th>Estado Asignado</th>
                      <th className="text-center">Rol</th>
                      <th>Estatus</th>
                      <th className="text-right">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtrados.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center" style={{ padding: '30px', color: 'var(--text-muted)' }}>
                          No se encontraron usuarios que coincidan con su búsqueda.
                        </td>
                      </tr>
                    ) : (
                      paginados.map(u => (
                        <tr key={u.id}>
                          <td><strong>{u.username}</strong></td>
                          <td>{u.first_name} {u.last_name}</td>
                          <td>{u.email}</td>
                          <td>{u.vicepresidencia_nombre || '—'}</td>
                          <td>{u.estado_asignado_nombre || '—'}</td>
                          <td className="text-center"><span className="role-badge">{u.role_display}</span></td>
                          <td>
                            <span className={`status-badge ${u.activo ? 'activo' : 'inactivo'}`}>
                              {u.activo ? 'Activo' : 'Inactivo'}
                            </span>
                          </td>
                          <td className="acciones-celda" style={{ textAlign: 'right' }}>
                            <button className="btn-small btn-edit" onClick={() => abrirModalUsuario(u)}>Editar</button>
                            <button className="btn-small btn-password" onClick={() => abrirModalPassword(u)} title="Cambiar Contraseña">🔑</button>
                            <button
                              className={`btn-small ${u.activo ? 'btn-reject' : 'btn-approve'}`}
                              onClick={() => toggleUsuario(u)}
                              disabled={!canToggleStatus(u)}
                              style={!canToggleStatus(u) ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                            >
                              {u.activo ? 'Desactivar' : 'Activar'}
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {filtrados.length > itemsPorPagina && (
                <div className="be-pagination-bar">
                  <button
                    onClick={() => setPaginaGlobal(prev => Math.max(prev - 1, 1))}
                    disabled={paginaGlobal === 1}
                    className="be-pagination-btn"
                  >
                    Anterior
                  </button>
                  <span className="be-pagination-info">
                    Página {paginaGlobal} de {totalPaginas}
                  </span>
                  <button
                    onClick={() => setPaginaGlobal(prev => Math.min(prev + 1, totalPaginas))}
                    disabled={paginaGlobal >= totalPaginas}
                    className="be-pagination-btn"
                  >
                    Siguiente
                  </button>
                </div>
              )}
            </div>
          </div>
        );
      })()}

      {/* ==================== VICEPRESIDENCIAS TAB ==================== */}
      {tabActiva === 'vicepresidencias' && (
        <div className="tab-content">
          <div className="section-header">
            <h3>Estructura de Vicepresidencias</h3>
            <button className="btn-primary" onClick={() => abrirModalVP()}>+ Nueva Vicepresidencia</button>
          </div>

          <div className="areas-grid">
            {vicepresidencias.map(vp => (
              <div key={vp.id} className={`area-card ${vp.activa ? '' : 'inactiva'}`}>
                <div className="area-header">
                  <h4>{vp.nombre} ({vp.abreviatura})</h4>
                </div>
                <p className="area-desc">{vp.descripcion || 'Sin descripción descriptiva.'}</p>
                <div className="area-footer">
                  <span className={`status-badge ${vp.activa ? 'activo' : 'inactivo'}`}>
                    {vp.activa ? 'Activa' : 'Inactiva'}
                  </span>
                  <div className="area-actions">
                    <button className="btn-small btn-edit" onClick={() => abrirModalVP(vp)}>Editar</button>
                    <button className={`btn-small ${vp.activa ? 'btn-reject' : 'btn-approve'}`} onClick={() => toggleVP(vp)}>
                      {vp.activa ? 'Desactivar' : 'Activar'}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ==================== GERENCIAS TAB ==================== */}
      {tabActiva === 'gerencias' && (
        <div className="tab-content bandeja-entrada">
          <div className="lista-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h2 className="bandeja-entrada-titulo">
              <span className="titulo-icono">🏢</span>
              Gerencias del Sistema
            </h2>
            <button className="btn-primary" onClick={() => abrirModalGerencia()}>+ Nueva Gerencia</button>
          </div>

          <div className="be-table-wrapper">
            <div className="be-card-header">
              <h3>Listado de Gerencias</h3>
              {(() => {
                let gerenciasDisponibles = gerencias;
                if (!esPresidente()) {
                  const miVpId = usuario?.vicepresidencia?.id || usuario?.vicepresidencia;
                  gerenciasDisponibles = gerencias.filter(g => String(g.vicepresidencia) === String(miVpId));
                }
                const filtrados = gerenciasDisponibles.filter(ger => {
                  const vpObj = vicepresidencias.find(v => v.id === ger.vicepresidencia);
                  const texto = `${ger.nombre} ${ger.descripcion} ${vpObj ? vpObj.nombre : ''}`.toLowerCase();
                  return texto.includes(busquedaGlobal.toLowerCase());
                });
                return <span className="be-count-pill">{filtrados.length} EN TOTAL</span>;
              })()}
            </div>

            {gerencias.length > 0 && (
              <div className="be-search-bar">
                <input
                  type="text"
                  placeholder="🔍 Buscar por nombre, descripción, vicepresidencia..."
                  value={busquedaGlobal}
                  onChange={(e) => {
                    setBusquedaGlobal(e.target.value);
                    setPaginaGlobal(1);
                  }}
                  className="be-search-input"
                />
              </div>
            )}

            <div className="be-table-responsive">
              <table className="be-table">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Vicepresidencia Asociada</th>
                    <th>Descripción</th>
                    <th>Estatus</th>
                    <th className="text-right">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    let gerenciasDisponibles = gerencias;
                    if (!esPresidente()) {
                      const miVpId = usuario?.vicepresidencia?.id || usuario?.vicepresidencia;
                      gerenciasDisponibles = gerencias.filter(g => String(g.vicepresidencia) === String(miVpId));
                    }
                    const filtrados = gerenciasDisponibles.filter(ger => {
                      const vpObj = vicepresidencias.find(v => v.id === ger.vicepresidencia);
                      const texto = `${ger.nombre} ${ger.descripcion} ${vpObj ? vpObj.nombre : ''}`.toLowerCase();
                      return texto.includes(busquedaGlobal.toLowerCase());
                    });
                    const indiceUltimo = paginaGlobal * itemsPorPagina;
                    const indicePrimero = indiceUltimo - itemsPorPagina;
                    const paginados = filtrados.slice(indicePrimero, indiceUltimo);

                    if (filtrados.length === 0) {
                      return (
                        <tr>
                          <td colSpan="5" className="text-center" style={{ padding: '30px', color: 'var(--text-muted)' }}>
                            No se encontraron gerencias que coincidan con su búsqueda.
                          </td>
                        </tr>
                      );
                    }

                    return paginados.map(ger => {
                      const vpObj = vicepresidencias.find(v => v.id === ger.vicepresidencia);
                      return (
                        <tr key={ger.id}>
                          <td><strong>{ger.nombre}</strong></td>
                          <td>{vpObj ? vpObj.nombre : `VP ID: ${ger.vicepresidencia}`}</td>
                          <td>{ger.descripcion || '—'}</td>
                          <td>
                            <span className={`status-badge ${ger.activa ? 'activo' : 'inactivo'}`}>
                              {ger.activa ? 'Activo' : 'Inactivo'}
                            </span>
                          </td>
                          <td className="acciones-celda" style={{ textAlign: 'right' }}>
                            <button className="btn-small btn-edit" onClick={() => abrirModalGerencia(ger)}>Editar</button>
                            <button className={`btn-small ${ger.activa ? 'btn-reject' : 'btn-approve'}`} onClick={() => toggleGerencia(ger)}>
                              {ger.activa ? 'Desactivar' : 'Activar'}
                            </button>
                          </td>
                        </tr>
                      );
                    });
                  })()}
                </tbody>
              </table>
            </div>

            {(() => {
              const filtrados = gerencias.filter(ger => {
                const vpObj = vicepresidencias.find(v => v.id === ger.vicepresidencia);
                const texto = `${ger.nombre} ${ger.descripcion} ${vpObj ? vpObj.nombre : ''}`.toLowerCase();
                return texto.includes(busquedaGlobal.toLowerCase());
              });
              const totalPaginas = Math.ceil(filtrados.length / itemsPorPagina);
              if (filtrados.length <= itemsPorPagina) return null;

              const indiceUltimo = Math.min(paginaGlobal * itemsPorPagina, filtrados.length);
              const indicePrimero = (paginaGlobal - 1) * itemsPorPagina + 1;

              return (
                <div className="be-pagination-bar">
                  <button
                    onClick={() => setPaginaGlobal(prev => Math.max(prev - 1, 1))}
                    disabled={paginaGlobal === 1}
                    className="be-pagination-btn"
                  >
                    Anterior
                  </button>
                  <span className="be-pagination-info">
                    Página {paginaGlobal} de {totalPaginas}
                  </span>
                  <button
                    onClick={() => setPaginaGlobal(prev => Math.min(prev + 1, totalPaginas))}
                    disabled={paginaGlobal >= totalPaginas}
                    className="be-pagination-btn"
                  >
                    Siguiente
                  </button>
                </div>
              );
            })()}
          </div>
        </div>
      )}

      {/* ==================== AUDITORÍA TAB ==================== */}
      {tabActiva === 'auditoria' && (
        <div className="tab-content">
          <div className="filtros-container">
            <h3>Filtros de Auditoría Completa</h3>
            <div className="filtros-grid">
              <div className="form-group">
                <label>Vicepresidencia</label>
                <select name="vicepresidencia" value={auditoriaFiltros.vicepresidencia} onChange={handleAuditoriaFiltroChange}>
                  <option value="">Todas</option>
                  {vicepresidencias.map(vp => (
                    <option key={vp.id} value={vp.id}>{vp.nombre}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Acción</label>
                <select name="accion" value={auditoriaFiltros.accion} onChange={handleAuditoriaFiltroChange}>
                  <option value="">Todas</option>
                  {accionesAuditoria.map(act => (
                    <option key={act.value} value={act.value}>{act.label}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Estado</label>
                <select name="estado" value={auditoriaFiltros.estado} onChange={handleAuditoriaFiltroChange}>
                  <option value="">Todos</option>
                  {estados.map(est => (
                    <option key={est.id} value={est.id}>{est.nombre}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Fecha Desde</label>
                <input type="date" name="fecha_desde" value={auditoriaFiltros.fecha_desde} onChange={handleAuditoriaFiltroChange} />
              </div>
              <div className="form-group">
                <label>Fecha Hasta</label>
                <input type="date" name="fecha_hasta" value={auditoriaFiltros.fecha_hasta} onChange={handleAuditoriaFiltroChange} />
              </div>
            </div>
            <div className="filtros-actions">
              <button className="btn-secondary" onClick={limpiarAuditoriaFiltros}>Limpiar Filtros</button>
              <button className="btn-primary" onClick={cargarAuditoria}>Aplicar Filtros</button>
            </div>
          </div>

          <div className="be-table-wrapper">
            <div className="be-card-header">
              <h3>Bitácora de Eventos de Auditoría (Línea de Tiempo)</h3>
              {(() => {
                const filtrados = auditoriaEventos.filter(ev => {
                  const texto = `${ev.requerimiento_correlativo} ${ev.usuario} ${ev.comentario} ${ev.accion_display}`.toLowerCase();
                  return texto.includes(busquedaGlobal.toLowerCase());
                });
                return <span className="be-count-pill">{filtrados.length} EN TOTAL</span>;
              })()}
            </div>

            {auditoriaEventos.length > 0 && (
              <div className="be-search-bar">
                <input
                  type="text"
                  placeholder="🔍 Buscar por ticket, usuario, comentario o acción..."
                  value={busquedaGlobal}
                  onChange={(e) => {
                    setBusquedaGlobal(e.target.value);
                    setPaginaGlobal(1);
                  }}
                  className="be-search-input"
                />
              </div>
            )}

            <div className="be-table-responsive">
              <table className="be-table audit-table">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Ticket</th>
                    <th>Usuario</th>
                    <th>Rol</th>
                    <th>Vicepresidencia</th>
                    <th>Estado</th>
                    <th>Acción</th>
                    <th>IP Cliente</th>
                    <th>Comentario</th>
                    <th>Cambios</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    const filtrados = auditoriaEventos.filter(ev => {
                      const texto = `${ev.requerimiento_correlativo} ${ev.usuario} ${ev.comentario} ${ev.accion_display}`.toLowerCase();
                      return texto.includes(busquedaGlobal.toLowerCase());
                    });
                    const indiceUltimo = paginaGlobal * itemsPorPagina;
                    const indicePrimero = indiceUltimo - itemsPorPagina;
                    const paginados = filtrados.slice(indicePrimero, indiceUltimo);

                    if (filtrados.length === 0) {
                      return (
                        <tr>
                          <td colSpan="10" className="text-center" style={{ padding: '30px', color: 'var(--text-muted)' }}>
                            No se encontraron eventos en la bitácora que coincidan con la búsqueda.
                          </td>
                        </tr>
                      );
                    }

                    return paginados.map(ev => {
                      const isExpanded = expandedEvents[ev.id];
                      return (
                        <React.Fragment key={ev.id}>
                          <tr>
                            <td>{formatFechaStr(ev.fecha)}</td>
                            <td><strong>{ev.requerimiento_correlativo}</strong></td>
                            <td>{ev.usuario}</td>
                            <td><span className="role-badge">{ev.rol_usuario}</span></td>
                            <td>{ev.vicepresidencia_nombre || '—'}</td>
                            <td>{ev.estado_venezolano}</td>
                            <td>
                              <span className="estado-badge" style={{ backgroundColor: getEstadoColor(ev.estado_nuevo) || '#6b7280', color: '#ffffff' }}>
                                {ev.accion_display}
                              </span>
                            </td>
                            <td><code>{ev.ip_address || 'Desconocida'}</code></td>
                            <td style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={ev.comentario}>
                              {ev.comentario || '—'}
                            </td>
                            <td>
                              <button className="btn-password" style={{ padding: '4px 8px', fontSize: '12px' }} onClick={() => toggleEventExpand(ev.id)}>
                                {isExpanded ? 'Ocultar Diffs' : 'Ver Diffs'}
                              </button>
                            </td>
                          </tr>
                          {isExpanded && (
                            <tr className="audit-expand-row">
                              <td colSpan="10" className="audit-expand-cell">
                                <div className="audit-expand-card">
                                  <h4 className="audit-expand-title">Snapshot de Auditoría</h4>
                                  {renderDiff(ev.datos_anteriores, ev.datos_nuevos)}
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    });
                  })()}
                </tbody>
              </table>
            </div>

            {(() => {
              const filtrados = auditoriaEventos.filter(ev => {
                const texto = `${ev.requerimiento_correlativo} ${ev.usuario} ${ev.comentario} ${ev.accion_display}`.toLowerCase();
                return texto.includes(busquedaGlobal.toLowerCase());
              });
              const totalPaginas = Math.ceil(filtrados.length / itemsPorPagina);
              if (filtrados.length <= itemsPorPagina) return null;

              const indiceUltimo = Math.min(paginaGlobal * itemsPorPagina, filtrados.length);
              const indicePrimero = (paginaGlobal - 1) * itemsPorPagina + 1;

              return (
                <div className="be-pagination-bar">
                  <button
                    onClick={() => setPaginaGlobal(prev => Math.max(prev - 1, 1))}
                    disabled={paginaGlobal === 1}
                    className="be-pagination-btn"
                  >
                    Anterior
                  </button>
                  <span className="be-pagination-info">
                    Página {paginaGlobal} de {totalPaginas}
                  </span>
                  <button
                    onClick={() => setPaginaGlobal(prev => Math.min(prev + 1, totalPaginas))}
                    disabled={paginaGlobal >= totalPaginas}
                    className="be-pagination-btn"
                  >
                    Siguiente
                  </button>
                </div>
              );
            })()}
          </div>
        </div>
      )}

      {/* ==================== CONFIGURACIÓN TAB ==================== */}
      {tabActiva === 'configuracion' && configuracion && (
        <div className="tab-content">
          <div className="config-container">
            <div className="config-section">
              <h4>🕐 Control de Horarios de Acceso Nocturno</h4>
              <div className="form-row">
                <div className="form-group">
                  <label>Hora de Inicio de Acceso</label>
                  <input type="time" name="hora_inicio_sesion" value={configForm.hora_inicio_sesion || ''} onChange={handleConfigChange} />
                </div>
                <div className="form-group">
                  <label>Hora de Bloqueo de Acceso</label>
                  <input type="time" name="hora_cierre_sesion" value={configForm.hora_cierre_sesion || ''} onChange={handleConfigChange} />
                </div>
              </div>
              <div className="form-group" style={{ marginTop: '14px' }}>
                <label>
                  <input type="checkbox" name="bloqueo_nocturno_activo" checked={configForm.bloqueo_nocturno_activo || false} onChange={handleConfigChange} />
                  Activar el Bloqueo Nocturno Automático (06:00 a 22:00 por defecto)
                </label>
              </div>
              <div className="form-group" style={{ marginTop: '10px' }}>
                <label>Roles Exentos del Bloqueo (separados por coma)</label>
                <input type="text" name="roles_exentos_bloqueo" value={configForm.roles_exentos_bloqueo || ''} onChange={handleConfigChange} placeholder="Ej: presidente, admin" />
              </div>
            </div>

            <div className="config-section">
              <h4>⚙️ Configuración del Portal</h4>
              <div className="form-group">
                <label>Nombre del Sistema</label>
                <input type="text" name="nombre_sistema" value={configForm.nombre_sistema || ''} onChange={handleConfigChange} />
              </div>
              <div className="form-group" style={{ marginTop: '10px' }}>
                <label>Mensaje de Bienvenida en Pantalla</label>
                <textarea name="mensaje_bienvenida" value={configForm.mensaje_bienvenida || ''} onChange={handleConfigChange} rows="3" />
              </div>
              <div className="form-row" style={{ marginTop: '10px' }}>
                <div className="form-group">
                  <label>Tiempo de Inactividad (minutos)</label>
                  <input type="number" min="1" max="1440" name="tiempo_inactividad_minutos" value={configForm.tiempo_inactividad_minutos || 15} onChange={handleConfigChange} />
                </div>
                <div className="form-group">
                  <label>Tamaño Máximo de Archivos (MB)</label>
                  <input type="number" min="1" max="100" name="tamano_maximo_archivo_mb" value={configForm.tamano_maximo_archivo_mb || 5} onChange={handleConfigChange} />
                </div>
              </div>
              <div className="form-group" style={{ marginTop: '14px' }}>
                <label>
                  <input type="checkbox" name="mantenimiento_activo" checked={configForm.mantenimiento_activo || false} onChange={handleConfigChange} />
                  Modo de Mantenimiento Activo (Deshabilita el portal temporalmente)
                </label>
              </div>
            </div>

            <div className="form-actions">
              <button className="btn-primary" onClick={guardarConfiguracion} disabled={guardandoConfig}>
                {guardandoConfig ? 'Guardando...' : 'Guardar Configuración'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ==================== PROVEEDORES TAB ==================== */}
      {tabActiva === 'proveedores' && (() => {
        const catsFiltradas = tiposProveedores.filter(c =>
          `${c.nombre} ${c.descripcion || ''}`.toLowerCase().includes(busquedaCategorias.toLowerCase())
        );
        const totalPaginasCat = Math.ceil(catsFiltradas.length / itemsPorPaginaCategorias);
        const catsPaginadas = catsFiltradas.slice(
          (paginaCategorias - 1) * itemsPorPaginaCategorias,
          paginaCategorias * itemsPorPaginaCategorias
        );

        const provsFiltrados = proveedores.filter(p =>
          `${p.nombre} ${p.rif} ${p.tipo_nombre || ''}`.toLowerCase().includes(busquedaProveedores.toLowerCase())
        );
        const totalPaginasProv = Math.ceil(provsFiltrados.length / itemsPorPaginaProveedores);
        const provsPaginados = provsFiltrados.slice(
          (paginaProveedores - 1) * itemsPorPaginaProveedores,
          paginaProveedores * itemsPorPaginaProveedores
        );

        return (
          <div className="tab-content bandeja-entrada">
            <div className="lista-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2 className="bandeja-entrada-titulo">
                <span className="titulo-icono">🤝</span>
                Directorio de Proveedores y Categorías
              </h2>
              <div style={{ display: 'flex', gap: '10px' }}>
                {subTabProveedores === 'categorias' && (
                  <button className="btn-primary" onClick={() => abrirModalNuevaCategoria()}>
                    + Nueva Categoría
                  </button>
                )}
                {subTabProveedores === 'proveedores' && (
                  <button className="btn-primary" onClick={() => abrirModalNuevoProveedor()}>
                    + Nuevo Proveedor
                  </button>
                )}
              </div>
            </div>

            <div className="admin-tabs" style={{ marginBottom: '20px', display: 'flex', gap: '10px', border: '1px solid var(--border)', borderRadius: '12px', padding: '6px' }}>
              <button
                className={`reporte-tab-btn ${subTabProveedores === 'categorias' ? 'active' : ''}`}
                onClick={() => setSubTabProveedores('categorias')}
              >
                <span style={{ fontSize: '1rem' }}>🏷️</span>
                <span>Categorías</span>
              </button>
              <button
                className={`reporte-tab-btn ${subTabProveedores === 'proveedores' ? 'active' : ''}`}
                onClick={() => setSubTabProveedores('proveedores')}
              >
                <span style={{ fontSize: '1rem' }}>🏢</span>
                <span>Proveedores</span>
              </button>
            </div>

            {subTabProveedores === 'categorias' && (
              <div className="be-table-wrapper" style={{ marginBottom: '30px' }}>
                <div className="be-card-header">
                  <h3>Listado de Categorías</h3>
                  <span className="be-count-pill">{catsFiltradas.length} EN TOTAL</span>
                </div>

                <div className="be-search-bar">
                  <input
                    type="text"
                    placeholder="🔍 Buscar por nombre o descripción..."
                    value={busquedaCategorias}
                    onChange={(e) => {
                      setBusquedaCategorias(e.target.value);
                      setPaginaCategorias(1);
                    }}
                    className="be-search-input"
                  />
                </div>

                <div className="be-table-responsive">
                  <table className="be-table">
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'left' }}>NOMBRE DE LA CATEGORÍA</th>
                        <th className="text-right">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {catsPaginadas.length === 0 ? (
                        <tr><td colSpan="2" style={{ textAlign: 'center' }}>No hay categorías registradas que coincidan con la búsqueda.</td></tr>
                      ) : (
                        catsPaginadas.map(c => (
                          <tr key={c.id}>
                            <td>
                              {c.nombre}
                              {!c.activo && <span className="status-badge inactivo" style={{ marginLeft: '10px' }}>Inactiva</span>}
                            </td>
                            <td className="text-right">
                              <div className="area-actions" style={{ justifyContent: 'flex-end' }}>
                                <button className="btn-small btn-edit" onClick={() => abrirModalNuevaCategoria(c)}>Editar</button>
                                <button className={`btn-small ${c.activo ? 'btn-reject' : 'btn-approve'}`} onClick={() => toggleCategoria(c)}>
                                  {c.activo ? 'Desactivar' : 'Activar'}
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
                {catsFiltradas.length > 0 && (
                  <div className="be-pagination-bar">
                    <button
                      onClick={() => setPaginaCategorias(prev => Math.max(prev - 1, 1))}
                      disabled={paginaCategorias === 1}
                      className="be-pagination-btn"
                    >
                      Anterior
                    </button>
                    <span className="be-pagination-info">
                      Página {paginaCategorias} de {totalPaginasCat}
                    </span>
                    <button
                      onClick={() => setPaginaCategorias(prev => Math.min(prev + 1, totalPaginasCat))}
                      disabled={paginaCategorias >= totalPaginasCat}
                      className="be-pagination-btn"
                    >
                      Siguiente
                    </button>
                  </div>
                )}
              </div>
            )}

            {subTabProveedores === 'proveedores' && (
              <div className="be-table-wrapper">
                <div className="be-card-header">
                  <h3>Listado de Proveedores</h3>
                  <span className="be-count-pill">{provsFiltrados.length} EN TOTAL</span>
                </div>

                <div className="be-search-bar">
                  <input
                    type="text"
                    placeholder="🔍 Buscar por nombre, RIF o categoría..."
                    value={busquedaProveedores}
                    onChange={(e) => {
                      setBusquedaProveedores(e.target.value);
                      setPaginaProveedores(1);
                    }}
                    className="be-search-input"
                  />
                </div>

                <div className="be-table-responsive">
                  <table className="be-table">
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'left' }}>NOMBRE DEL PROVEEDOR</th>
                        <th style={{ textAlign: 'left' }}>RIF</th>
                        <th style={{ textAlign: 'left' }}>CATEGORÍA</th>
                        <th className="text-right">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cargandoProveedores ? (
                        <tr><td colSpan="4" style={{ textAlign: 'center' }}>Cargando proveedores...</td></tr>
                      ) : provsPaginados.length === 0 ? (
                        <tr><td colSpan="4" style={{ textAlign: 'center' }}>No hay proveedores registrados que coincidan con la búsqueda.</td></tr>
                      ) : (
                        provsPaginados.map(p => (
                          <tr key={p.id}>
                            <td>
                              {p.nombre}
                              {!p.activo && <span className="status-badge inactivo" style={{ marginLeft: '10px' }}>Inactivo</span>}
                            </td>
                            <td>{p.rif}</td>
                            <td>{p.tipo_nombre || 'N/A'}</td>
                            <td className="text-right">
                              <div className="area-actions" style={{ justifyContent: 'flex-end' }}>
                                <button className="btn-small btn-edit" onClick={() => abrirModalNuevoProveedor(p)}>Editar</button>
                                <button className={`btn-small ${p.activo ? 'btn-reject' : 'btn-approve'}`} onClick={() => toggleProveedor(p)}>
                                  {p.activo ? 'Desactivar' : 'Activar'}
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
                {provsFiltrados.length > 0 && (
                  <div className="be-pagination-bar">
                    <button
                      onClick={() => setPaginaProveedores(prev => Math.max(prev - 1, 1))}
                      disabled={paginaProveedores === 1}
                      className="be-pagination-btn"
                    >
                      Anterior
                    </button>
                    <span className="be-pagination-info">
                      Página {paginaProveedores} de {totalPaginasProv}
                    </span>
                    <button
                      onClick={() => setPaginaProveedores(prev => Math.min(prev + 1, totalPaginasProv))}
                      disabled={paginaProveedores >= totalPaginasProv}
                      className="be-pagination-btn"
                    >
                      Siguiente
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })()}

      {/* ==================== MODAL CATEGORIA DE PROVEEDOR ==================== */}
      {showNuevaCategoriaModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <div className="modal-alert-content" style={{ padding: '24px 24px 12px' }}>
              <h3 className="modal-title">{categoriaEditando ? 'Editar Categoría' : 'Nueva Categoría'}</h3>
              <p className="modal-message">Defina un rubro o tipo de proveedor (ej: Tecnología, Construcción).</p>

              {errorCategoriaModal && <div className="error-message" style={{ width: '100%', marginTop: '12px' }}>⚠️ {errorCategoriaModal}</div>}

              <div className="form-group" style={{ width: '100%', marginTop: '16px', textAlign: 'left' }}>
                <label style={{ fontSize: '13px', fontWeight: '600', color: '#475569' }}>Nombre de la Categoría *</label>
                <input
                  type="text"
                  value={nuevaCategoriaNombre}
                  onChange={(e) => setNuevaCategoriaNombre(e.target.value)}
                  placeholder="Ej: Materiales de Oficina"
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #cbd5e1', borderRadius: '8px', marginTop: '4px' }}
                />
              </div>
            </div>
            <div className="modal-actions">
              <button
                type="button"
                className="modal-btn modal-btn-cancel"
                onClick={() => setShowNuevaCategoriaModal(false)}
                disabled={cargandoNuevaCategoria}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="modal-btn modal-btn-confirm"
                onClick={handleCrearCategoria}
                disabled={cargandoNuevaCategoria || !nuevaCategoriaNombre.trim()}
              >
                {cargandoNuevaCategoria ? 'Guardando...' : 'Guardar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ==================== MODAL PROVEEDOR ==================== */}
      {showNuevoProveedorModal && (
        <div className="modal-overlay">
          <div className="modal-box" style={{ maxWidth: '480px' }}>
            <div className="modal-alert-content" style={{ padding: '24px 24px 12px' }}>
              <h3 className="modal-title">{proveedorEditando ? 'Editar Proveedor' : 'Nuevo Proveedor'}</h3>
              <p className="modal-message">Registre los datos comerciales del proveedor en la base de datos.</p>

              {errorProveedorModal && <div className="error-message" style={{ width: '100%', marginTop: '12px' }}>⚠️ {errorProveedorModal}</div>}

              <div className="form-group" style={{ width: '100%', marginTop: '16px', textAlign: 'left' }}>
                <label style={{ fontSize: '13px', fontWeight: '600' }}>Nombre del Proveedor *</label>
                <input
                  type="text"
                  value={nuevoProveedorData.nombre}
                  onChange={(e) => setNuevoProveedorData(prev => ({ ...prev, nombre: e.target.value }))}
                  placeholder="Ej: Inversiones 123 C.A."
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #cbd5e1', borderRadius: '8px', marginTop: '4px' }}
                />
              </div>

              <div className="form-group" style={{ width: '100%', marginTop: '12px', textAlign: 'left' }}>
                <label style={{ fontSize: '13px', fontWeight: '600' }}>Categoría / Tipo *</label>
                <select
                  value={nuevoProveedorData.tipo}
                  onChange={(e) => setNuevoProveedorData(prev => ({ ...prev, tipo: e.target.value }))}
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #cbd5e1', borderRadius: '8px', marginTop: '4px' }}
                >
                  <option value="">-- Seleccione categoría --</option>
                  {tiposProveedores.map(t => (
                    <option key={t.id} value={t.id}>{t.nombre}</option>
                  ))}
                </select>
              </div>

              <div className="form-group" style={{ width: '100%', marginTop: '12px', textAlign: 'left' }}>
                <label style={{ fontSize: '13px', fontWeight: '600' }}>RIF *</label>
                <div className="cedula-input-group" style={{ marginTop: '4px', display: 'flex', gap: '5px' }}>
                  <select
                    value={nuevoProveedorData.tipo_documento}
                    onChange={(e) => setNuevoProveedorData(prev => ({ ...prev, tipo_documento: e.target.value }))}
                    className="select-nacionalidad"
                    style={{ flex: '0 0 60px', padding: '10px', border: '1px solid #cbd5e1', borderRadius: '8px' }}
                    disabled={!!proveedorEditando}
                  >
                    <option value="">-</option>
                    {tiposDocumentos.map(td => (
                      <option key={td.id} value={td.id}>{td.sigla}</option>
                    ))}
                  </select>
                  <input
                    type="text"
                    value={nuevoProveedorData.rif_numero}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, '');
                      setNuevoProveedorData(prev => ({ ...prev, rif_numero: val }));
                    }}
                    placeholder="Número de RIF (sin letras)"
                    className="input-cedula-num"
                    style={{ flex: '1', padding: '10px 12px', border: '1px solid #cbd5e1', borderRadius: '8px' }}
                    disabled={!!proveedorEditando}
                  />
                </div>
                {proveedorEditando && <small style={{ color: '#64748b', fontSize: '12px', marginTop: '4px', display: 'block' }}>El RIF no se puede modificar.</small>}
              </div>
            </div>
            <div className="modal-actions">
              <button
                type="button"
                className="modal-btn modal-btn-cancel"
                onClick={() => setShowNuevoProveedorModal(false)}
                disabled={cargandoNuevoProveedor}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="modal-btn modal-btn-confirm"
                onClick={handleCrearProveedor}
                disabled={cargandoNuevoProveedor || !nuevoProveedorData.tipo || !nuevoProveedorData.nombre || !nuevoProveedorData.tipo_documento || !nuevoProveedorData.rif_numero}
              >
                {cargandoNuevoProveedor ? 'Guardando...' : 'Guardar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ==================== MODAL VICEPRESIDENCIA ==================== */}
      {modalVP && (
        <div className="modal-overlay" onClick={() => setModalVP(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h3>{vpEditando ? 'Editar Vicepresidencia' : 'Nueva Vicepresidencia'}</h3>
            <div className="modal-form">

              <div className="form-group">
                <label>Nombre</label>
                <input type="text" value={vpForm.nombre} onChange={e => setVpForm(p => ({ ...p, nombre: e.target.value }))} placeholder="Ej: Vicepresidencia Comercial de Ventas" />
              </div>
              <div className="form-group">
                <label>Abreviatura (2-4 caracteres)</label>
                <input type="text" maxLength="4" value={vpForm.abreviatura} onChange={e => setVpForm(p => ({ ...p, abreviatura: e.target.value.toUpperCase() }))} placeholder="Ej: VC" />
              </div>
              <div className="form-group">
                <label>Descripción</label>
                <textarea value={vpForm.descripcion} onChange={e => setVpForm(p => ({ ...p, descripcion: e.target.value }))} rows="3" />
              </div>
              <div className="modal-actions">
                <button className="btn-secondary" onClick={() => setModalVP(false)}>Cancelar</button>
                <button className="btn-primary" onClick={guardarVP}>Guardar</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ==================== MODAL GERENCIA ==================== */}
      {modalGerencia && (
        <div className="modal-overlay" onClick={() => setModalGerencia(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h3>{gerenciaEditando ? 'Editar Gerencia' : 'Nueva Gerencia'}</h3>
            <div className="modal-form">
              <div className="form-group">
                <label>Vicepresidencia Asociada</label>
                <select
                  value={gerenciaForm.vicepresidencia}
                  onChange={e => setGerenciaForm(p => ({ ...p, vicepresidencia: parseInt(e.target.value) }))}
                  disabled={!esPresidente()}
                >
                  {vicepresidencias.map(vp => (
                    <option key={vp.id} value={vp.id}>{vp.nombre}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Nombre de la Gerencia</label>
                <input type="text" value={gerenciaForm.nombre} onChange={e => setGerenciaForm(p => ({ ...p, nombre: e.target.value }))} placeholder="Ej: Gerencia Comercial de Distribución" />
              </div>
              <div className="form-group">
                <label>Descripción</label>
                <textarea value={gerenciaForm.descripcion} onChange={e => setGerenciaForm(p => ({ ...p, descripcion: e.target.value }))} rows="3" />
              </div>
              <div className="modal-actions">
                <button className="btn-secondary" onClick={() => setModalGerencia(false)}>Cancelar</button>
                <button className="btn-primary" onClick={guardarGerencia}>Guardar</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ==================== MODAL USUARIO ==================== */}
      {modalUsuario && (
        <div className="modal-overlay" onClick={() => setModalUsuario(false)}>
          <div className="modal-content modal-lg" onClick={e => e.stopPropagation()}>
            <h3>{usuarioEditando ? 'Editar Usuario' : 'Nuevo Usuario'}</h3>
            <div className="modal-form">
              <div className="form-row">
                <div className="form-group">
                  <label>Nombre de Usuario *</label>
                  <input type="text" value={usuarioForm.username} onChange={e => setUsuarioForm(p => ({ ...p, username: e.target.value }))} disabled={!!usuarioEditando} />
                </div>
                {!usuarioEditando && (
                  <div className="form-group">
                    <label>Contraseña *</label>
                    <input type="password" value={usuarioForm.password} onChange={e => setUsuarioForm(p => ({ ...p, password: e.target.value }))} />
                  </div>
                )}
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Nombre</label>
                  <input type="text" value={usuarioForm.first_name} onChange={e => setUsuarioForm(p => ({ ...p, first_name: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label>Apellido</label>
                  <input type="text" value={usuarioForm.last_name} onChange={e => setUsuarioForm(p => ({ ...p, last_name: e.target.value }))} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Cédula *</label>
                  <input type="text" value={usuarioForm.cedula} onChange={e => setUsuarioForm(p => ({ ...p, cedula: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label>Correo Electrónico</label>
                  <input type="email" value={usuarioForm.email} onChange={e => setUsuarioForm(p => ({ ...p, email: e.target.value }))} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Teléfono</label>
                  <input type="text" value={usuarioForm.telefono} onChange={e => setUsuarioForm(p => ({ ...p, telefono: e.target.value }))} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Rol de Usuario</label>
                  <select value={usuarioForm.role} disabled={esAsistenteVicepresidencia() || esAdministracion()} onChange={e => setUsuarioForm(p => ({ ...p, role: e.target.value }))}>
                    <option value="">— Seleccione Rol —</option>
                    {(esPresidente() ? [
                      { value: 'administracion', label: 'Administración' },
                      { value: 'analista_administracion', label: 'Analista de Administración' },
                      { value: 'vicepresidencia', label: 'Vicepresidencia' },
                      { value: 'asistente_vicepresidencia', label: 'Asistente Vicepresidencia' },
                      { value: 'analista', label: 'Analista' },
                    ] : esAdministracion() ? [
                      { value: 'analista_administracion', label: 'Analista de Administración' },
                    ] : esVicepresidencia() ? [
                      { value: 'asistente_vicepresidencia', label: 'Asistente Vicepresidencia' },
                      { value: 'analista', label: 'Analista' },
                    ] : esAsistenteVicepresidencia() ? [
                      { value: 'analista', label: 'Analista' },
                    ] : []).map(r => (
                      <option key={r.value} value={r.value}>{r.label}</option>
                    ))}
                  </select>
                </div>
                {usuarioForm.role !== 'presidente' && usuarioForm.role !== 'administracion' && usuarioForm.role !== 'analista_administracion' && (
                  <div className="form-group">
                    <label>Vicepresidencia Asignada</label>
                    <select value={usuarioForm.vicepresidencia} disabled={!esPresidente()} onChange={e => setUsuarioForm(p => ({ ...p, vicepresidencia: parseInt(e.target.value) }))}>
                      <option value="">— Seleccione —</option>
                      {vicepresidencias.filter(vp => vp.tipo !== 'presidencia').map(vp => (
                        <option key={vp.id} value={vp.id}>{vp.nombre}</option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
              {usuarioForm.role === 'analista' && (
                <div className="form-row">
                  <div className="form-group toggle-group">
                    <div className="toggle-container">
                      <input
                        type="checkbox"
                        id="es_sede_central"
                        checked={usuarioForm.es_sede_central !== false}
                        onChange={e => setUsuarioForm(p => ({ ...p, es_sede_central: e.target.checked }))}
                      />
                      <label htmlFor="es_sede_central" className="toggle-slider"></label>
                    </div>
                    <div className="toggle-label-info">
                      <strong>Sede Central</strong>
                      <p>Desmarque si el analista está asignado a un estado específico</p>
                    </div>
                  </div>
                  {!usuarioForm.es_sede_central && (
                    <div className="form-group">
                      <label>Estado Venezolano Asignado (Obligatorio para Analistas no Sede Central)</label>
                      <select value={usuarioForm.estado_asignado} onChange={e => setUsuarioForm(p => ({ ...p, estado_asignado: parseInt(e.target.value) }))}>
                        <option value="">— Seleccione un Estado —</option>
                        {estados.map(est => (
                          <option key={est.id} value={est.id}>{est.nombre}</option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
              )}
              <div className="modal-actions">
                <button className="btn-secondary" onClick={() => setModalUsuario(false)}>Cancelar</button>
                <button className="btn-primary" onClick={guardarUsuario}>Guardar</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ==================== MODAL CAMBIAR CONTRASEÑA ==================== */}
      {modalPassword && usuarioPassword && (
        <div className="modal-overlay" onClick={() => setModalPassword(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h3>Restablecer Contraseña</h3>
            <p className="password-user-info">Usuario: <strong>{usuarioPassword.username}</strong></p>
            <div className="modal-form">
              <div className="form-group">
                <label>Nueva Contraseña (mínimo 8 caracteres)</label>
                <input type="password" value={passwordForm.nueva_password} onChange={e => setPasswordForm(p => ({ ...p, nueva_password: e.target.value }))} />
              </div>
              <div className="form-group">
                <label>Confirmar Nueva Contraseña</label>
                <input type="password" value={passwordForm.confirmar_password} onChange={e => setPasswordForm(p => ({ ...p, confirmar_password: e.target.value }))} />
              </div>
              <div className="modal-actions">
                <button className="btn-secondary" onClick={() => setModalPassword(false)}>Cancelar</button>
                <button className="btn-primary" onClick={guardarPassword} disabled={guardandoPassword}>
                  {guardandoPassword ? 'Procesando...' : 'Cambiar Contraseña'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Alertas del Sistema */}
      <Modal
        {...modalConfig}
        onClose={() => setModalConfig({ ...modalConfig, isOpen: false })}
      />
    </div>
  );
};

export default AdminDashboard;
